import {
  collectFlowElementIds,
  FlowElementTextOverlayContext,
} from "@redotech/redo-customer-portal-shared/flow-element-text";
import { useFlowElementTextOverlay } from "@redotech/redo-customer-portal-shared/flow-element-text-overlay";
import { memo, ReactNode, useContext, useMemo } from "react";
import { SettingsContext } from "./settings";

/** Until the first response lands the overlay is empty, so the portal renders English. */
export const FlowElementTextOverlayProvider = memo(
  function FlowElementTextOverlayProvider({
    children,
  }: {
    children: ReactNode;
  }) {
    const settings = useContext(SettingsContext);

    const elementIds = useMemo(
      () =>
        collectFlowElementIds([
          settings?.returnFlow,
          settings?.claimFlow,
          settings?.finalizeReturnFlow,
          settings?.finalizeClaimFlow,
          settings?.warrantyFlow,
        ]),
      [
        settings?.returnFlow,
        settings?.claimFlow,
        settings?.finalizeReturnFlow,
        settings?.finalizeClaimFlow,
        settings?.warrantyFlow,
      ],
    );
    const overlay = useFlowElementTextOverlay({
      elementIds,
      localization: settings?.localization,
    });

    return (
      <FlowElementTextOverlayContext.Provider value={overlay}>
        {children}
      </FlowElementTextOverlayContext.Provider>
    );
  },
);
